import type { Time, TimeBrandSymbol } from '@hunting-nature/shared-core/types/time.type';
import { createBrander } from '@hunting-nature/shared-core/utils/create-brander';

export function createTime(hhmm: string, baseDate: Date = new Date()): Time {
  const [hours, minutes] = hhmm.split(':').map(Number);
  const date = new Date(baseDate);
  date.setHours(hours, minutes, 0, 0);

  return createBrander<Date, typeof TimeBrandSymbol>()(date);
}
